import { useRef } from 'react';
import { Button, Form, Icon, IconButton, ResponsiveDialog, Stack, Text, TextArea, TextInput } from 'shell/components';

const EditCriterionDialog = ({ open, criterion, onClose, onSave, onDelete }) => {
    const titleRef = useRef(null);
    const descriptionRef = useRef(null);

    const { id, title, description } = criterion;

    const handleSubmit = () => {
        onSave(id, titleRef.current.value, descriptionRef.current.value);
    };

    return (
        <ResponsiveDialog open={open} onClose={onClose}>
            <Stack sx={{ minWidth: '300px' }} spacing={4}>
                <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                    <Text variant={'h6'} weight={'semibold'}>
                        Edit Criterion
                    </Text>
                    <IconButton kind={'exit'} size={'medium'} variant={'square'} onClick={onClose} />
                </Stack>
                <Form onSubmit={handleSubmit}>
                    <Stack spacing={4}>
                        <TextInput
                            ref={titleRef}
                            autoFocus
                            defaultValue={title}
                            label={'Name'}
                            placeholder={'Enter criterion name'}
                        />
                        <TextArea
                            ref={descriptionRef}
                            defaultValue={description}
                            label={'Description'}
                            placeholder={'Enter criterion description'}
                            rows={4}
                        />
                        <Stack direction={'row'} justifyContent={'space-between'}>
                            <Button
                                color={'destructive'}
                                startIcon={<Icon kind={'delete'} />}
                                type={'button'}
                                variant={'tertiary'}
                                onClick={() => onDelete(criterion.id)}
                            >
                                Delete
                            </Button>
                            <Button type={'submit'}>Save</Button>
                        </Stack>
                    </Stack>
                </Form>
            </Stack>
        </ResponsiveDialog>
    );
};

export default EditCriterionDialog;
